import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function VehicleTransactionsCtrl (
  $scope,
  $state,
  $translate,
  messages,
  workshopAPI
) {
  $scope.showVehicleTransactions = !!$scope.transactions.length;

  $scope.tableSettings = {
    columns: [
      {
        field: 'transaction_time',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.TIME')
        },
        pipe: 'date',
        pipeArgs: 'hh:mm a'
      },
      {
        field: 'transaction_note',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.NOTE')
        }
      },
      {
        field: 'transaction_amount',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewTransaction(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TRANSACTIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/dealership_transaction_logs/count_for_vehicle/' + $scope.vehicle.id)
    },
    rows: {
      highlight: {
        enabled: true
      },
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getTransactions = ( params ) => {
    return workshopAPI.get('/dealership_transaction_logs/index_for_vehicle', [
      $scope.vehicle.id,
      params.offset,
      params.pageSize,
    ]).then(transactions => {
      $scope.transactions = transactions;

      return transactions;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewTransaction(event.row);
  };

  $scope.viewTransaction = function (transaction) {
    workshopAPI.get('/dealership_transaction_logs/link_details_for_log', transaction.id)
    .then(function (data) {
      data.object === 'invoice'
        ? $state.go('app.dealership.sale', {
            customer_id: data.parent_id,
            vehicle_id : data.vehicle_id,
            id         : data.id
          })
        : $state.go('app.vendor-invoice', {
            vendor_id : data.parent_id,
            vehicle_id: data.vehicle_id,
            id        : data.id
          });
    }, function (error) {
      messages.error(error);
    });
  };
};